import React from "react";
import classNames from "classnames";
import { UseFormRegister } from "react-hook-form";

type Props = {
  type: string;
  placeholder: string;
  label: string;
  layout?: string;
  errorMessage?: string;
  required?: boolean;
  className?: string;
  name: string;
  disabled?: boolean;
  register: UseFormRegister<any>;
};

export const InputField: React.FC<Props> = ({
  register,
  label,
  placeholder,
  className,
  required,
  type,
  disabled,
  name,
  errorMessage,
  layout,
}) => {
  return (
    <div className={layout}>
      <label htmlFor={label} className="field-label">
        {label} {required && <span className="text-primary">*</span>}
      </label>
      <input
        id={label}
        type={type}
        {...register(name)}
        disabled={disabled}
        placeholder={placeholder}
        className={classNames(
          "block w-full rounded-lg bg-white border px-3 py-2.5 text-sm text-ink placeholder:text-ink-muted",
          "focus:outline-none transition-[border-color,box-shadow] duration-150",
          "disabled:bg-surface-muted disabled:text-ink-muted disabled:cursor-not-allowed",
          {
            "border-red-400 focus:border-red-500 focus:shadow-[0_0_0_3px_rgba(239,68,68,.15)]":
              !!errorMessage,
            "border-line focus:border-line-strong focus:shadow-focus": !errorMessage,
          },
          className
        )}
      />
      {errorMessage && (
        <p className="mt-1 text-xs font-medium text-red-600">{errorMessage}</p>
      )}
    </div>
  );
};

export const inputStyles = {
  input:
    "mt-1 placeholder:text-sm rounded-lg text-ink appearance-none bg-white block w-full p-2.5 border border-line placeholder:text-ink-muted focus:outline-none focus:border-line-strong focus:shadow-focus text-sm transition-[border-color,box-shadow] duration-150 ",
  error:
    "border-red-400 focus:border-red-500 focus:shadow-[0_0_0_3px_rgba(239,68,68,.15)] placeholder:text-red-400/70 ",
  focused: "focus:border-line-strong",
  errorMessage: "text-red-600 text-xs font-medium mt-1",
};
